const paymentProviders = {
    /* eslint-disable sort-keys */
    UNKNOWN: 0,
    // Square is no longer supported, leaving as a reference point
    // SQUARE: 1,
    STRIPE: 2,
    PAYRIX: 3,
    PAYSAFE: 4,
    /* eslint-enable sort-keys */
} as const;

export default paymentProviders;
